<template>
  <svg
    style="height: 1em; height: 1em"
    viewBox="0 0 48 48"
    fill="none"
    stroke="currentColor"
    stroke-width="4"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M19 4H37L26 18H41L17 44L22 25H8L19 4Z" stroke-linejoin="round" />
  </svg>
</template>
